import { mapGetters } from 'vuex';
import keyboardNumericInput from '@/components/keyboard-numeric-input/keyboard-numeric-input.vue';

export default {
  components: {
    keyboardNumericInput,
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price',
    },
    value: {
      type: Number,
      default: 50,
    },
    kind: {
      type: String,
      default: 'modal',
    },
    selected: Boolean,
    tabindex: Number,
    minValue: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      cents: this.value !== null ? parseInt(this.value, 10) : 0,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    classModifier() {
      return {
        'purchase-offer-value': true,
        [`purchase-offer-value--${this.kind}`]: this.kind,
        'purchase-offer-value--selected': this.selected,
      };
    },
  },
  watch: {
    cents: 'updateOffer',
    value(value) {
      this.cents = value !== null ? parseInt(value, 10) : 0;
    },
  },
  methods: {
    add() {
      if (isNaN(this.cents) || this.cents === null) this.cents = 0;
      this.cents += 1;
    },
    subtract() {
      if (isNaN(this.cents) || this.cents === null) this.cents = 0;
      let newValue = this.cents - 1;
      this.cents = Math.max(newValue, this.minValue);
    },
    updateOffer() {
      this.cents = parseInt(this.cents, 10);
      if (isNaN(this.cents) || this.cents < 1) this.cents = null;
      else if (this.cents > 99) this.cents = 99;

      if (this.cents !== null) {
        this.$emit('input', Number(this.cents));
      } else {
        this.$emit('input', this.cents);
      }
    },
    click() {
      this.$emit('click');
    },
    onBoxClick() {
      if (this.isLayoutDesktop) {
        this.$refs.input.focus();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/purchase-offer-value/purchase-offer-value.js